export const Bio = {
  name: "Raunak Agarwal",
  roles: ["Entrepreneur", "Product AI Engineer", "Full Product Owner"],
  description:
    "I am an entrepreneur and Product AI Engineer currently leading the full product at FindATutor, a startup based in Switzerland. I build and ship AI-powered products end to end, from product thinking and user experience to engineering and deployment. I am currently focused on two products: FindATutor and Rentally.",
  github: "https://github.com/raunak173",
  resume:
    "https://drive.google.com/file/d/1bpCF96wWP8dzKGLubjIlypPg-gVuepvG/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/raunakagarwal173/",
  twitter: "https://twitter.com/raunak_173",
  insta: "https://www.instagram.com/raunak_agarwal_/",
  facebook:
    "https://www.facebook.com/p/raunak-agarwal-100006877748872/?mibextid=LQQJ4d",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next.js",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Figma",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
      },
      {
        name: "Canva",
        image: "https://static.canva.com/static/images/favicon.ico",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node.js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Supabase",
        image:
          "https://seeklogo.com/images/S/supabase-logo-DCC676FFE2-seeklogo.com.png",
      },
      {
        name: "Postgres",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Codex",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/4/4d/OpenAI_Logo.svg",
      },
      {
        name: "OpenAI",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/4/4d/OpenAI_Logo.svg",
      },
      {
        name: "Claude",
        image:
          "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/dark/claude-color.png",
      },
      {
        name: "PostHog",
        image: "https://posthog.com/brand/posthog-logo.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://findatutor.ch/assets/images/logo-dark.png",
    role: "Product AI Engineer",
    company: "FindATutor",
    date: "Oct 2025 - Present",
    desc: "At FindATutor, a Switzerland-based startup, I lead the full product end to end as a Product AI Engineer, owning the complete journey from idea to launch. I handle product planning, feature planning, user flows, design direction, development, testing, deployment, and iteration across the platform. My work sits at the intersection of product, engineering, and AI, where I turn business goals into real product experiences and ship them fast with a strong focus on usability, speed, and execution. Alongside FindATutor, I am also the cofounder of Rentally, a stealth rental platform being built for people in Switzerland, where I am actively shaping the product vision, feature roadmap, and overall execution.",
    skills: [
      "Codex",
      "OpenAI",
      "Claude",
      "React",
      "Next.js",
      "Figma",
      "Canva",
      "Node.js",
      "Express",
      "PostHog",
      "Firebase",
      "Supabase",
      "Postgres",
      "JavaScript",
    ],
  },
  {
    id: 0,
    img: "https://play-lh.googleusercontent.com/7doL4LTavTVEG8B3NdDfZqm44sm9__MXNlhz6YobzZxMY5rvCgMmf6dyLAColCMSuU4=w240-h480-rw",
    role: "Frontend Engineer (React Native)",
    company: "Alyke",
    date: "Jan 2025 - Oct 2025",
    desc: "Led the development and optimization of the Alyke app, the world’s first friendship app, enhancing performance and user experience through efficient code refactoring and bug fixes. Integrated Meta Analytics, Revopush OTA, and Fastlane, streamlining deployment and improving tracking of user interactions for data-driven insights and Implemented real-time messaging using Firestore and React Native Gifted Chat, ensuring a seamless chat experience, and utilized Redux and Redux-Saga for efficient state management.",
    skills: [
      "React Native",
      "Typescript",
      "Javascript",
      "Android studio",
      "X Code",
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDN-wdoAiyDHgNjqZs3DeSxwYM2wc8mYDTVQ&s",
    role: "SDE-1 (React Native)",
    company: "TapHealth",
    date: "Aug 2024 - Jan 2025",
    desc: "Spearheaded the release management of a cross-platform health tech app on the Play Store and App Store, ensuring seamless deployment and version updates. Optimized the app’s codebase for improved performance and efficiency, resulting in faster load times and smoother user interactions. Developed and implemented dynamic, animated UIs and new features such as diet tracking and DTX (Digital Therapeutics) modules to enhance user engagement, using React Native. Ensured seamless functionality across both Android and iOS platforms while improving app scalability to support future growth and feature additions.",
    skills: [
      "React Native",
      "Typescript",
      "Javascript",
      "Android studio",
      "X Code",
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgl4a4RxO1LKn1edeAM7FkMBdMTMMT_jFbVA&s",
    role: "Frontend Developer (React Native & React JS)",
    company: "Sigiq AI (Stealth)",
    date: "Apr 2024 - Aug 2024",
    desc: "Contributed to the PadhAi app, the world’s only AI app that cracked the UPSC exam and topped it with a score of 175+ marks, using React Native. Developed a live website for an important event with over 10,000 footfalls using React. Created a live web app with AI capabilities for UPSC teachers to grade essays.",
    skills: [
      "React Native",
      "Typescript",
      "Javascript",
      "Android studio",
      "React JS",
      "AWS",
      "EC2",
      "nginx",
      "s3",
    ],
    // doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
  {
    id: 1,
    img: "https://docs.nudgenow.com/img/logomark.png",
    role: "SDE-Intern (React-Native)",
    company: "Nudgenow",
    date: "Nov 2023 - Apr 2024",
    desc: "Spearheaded the development and implementation of cutting-edge Software Development Kits (SDKs) to address critical functionality gaps in 5+ high-impact projects to increase user engagement by 30%. Orchestrated the seamless integration of innovative React Native SDKs into 10+ high-profile mobile applications, including those owned by Apnaclub, Centa, Tata Communications, and many more.",
    skills: [
      "React Native",
      "Typescript",
      "Javascript",
      "Android studio",
      "React JS",
      "SDK",
    ],
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7cEoQTCU449dh3f0GBiBKY2uhUKX6QFS2uA&s",
    role: "Full Stack Intern (React Native & Spring Boot)",
    company: "Doeasily",
    date: "Aug 2023 - Nov 2023",
    desc: "Pioneered the creation of the DoEasily fintech app for the gold and silver market using React Native, achieving a 100% project completion rate. Engineered high-performance APIs with Java and Spring Boot, resulting in a 30% reduction in data retrieval time and a 20% improvement in app response speed.",
    skills: [
      "React Native",
      "Javascript",
      "Android studio",
      "Java",
      "Spring Boot",
    ],
    // doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
  },
  {
    id: 3,
    img: "https://images.jdmagicbox.com/v2/comp/bangalore/g3/080pxx80.xx80.221014213454.r4g3/catalogue/medbikri-hsr-layout-sector-2-bangalore-software-companies-a4fekik628-250.jpg",
    role: "SDET Intern (React Native & Appium & Express JS)",
    company: "Medbikri",
    date: "Dec 2022 - July 2022",
    desc: "Spearheaded the development of a React Native mobile application, serving 100,000+ users. Enabled seamless and intuitive user experiences through precisely crafted Express APIs, resulting in increased user engagement and higher conversion rates. Automated testing with Appium, significantly reducing bugs by 70% and enhancing software quality.",
    skills: [
      "React Native",
      "Javascript",
      "Expess JS",
      "GraphQl",
      "Appium",
      "Cucumber",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Kiit.jpeg?alt=media&token=3839d520-c59d-4341-ad8f-0980c98de4dd",
    school: "Kalinga Institute of Industrial Technology, Bhubaneswar",
    date: "Oct 2021 - Sep 2025",
    grade: "8.71 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Kalinga Institute of Industrial Technology, Bhubaneswar. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
    school: "Methodist School, Dankuni",
    date: "Apr 2019 - Apr 2025",
    grade: "88.2%",
    desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
    degree: "ISC(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/methodist.png?alt=media&token=018a1b18-e2dd-4f34-8855-cff1b6b69fd3",
    school: "Methodist School, Dankuni",
    date: "Apr 2017 - Apr 2019",
    grade: "92.3%",
    desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
    degree: "ICSC(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 9,
    title: "Go-bms",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Built scalable backend using Gin Gonic, GORM, and PostgreSQL, efficiently handling over 500+ ticket bookings per second. Optimized database transactions to resolve race conditions and handle concurrency, ensuring 100% data integrity during simultaneous ticket bookings. Implemented OTP verification for user authentication using Twilio API, successfully processing 10,000+ OTPs daily with a 95% success rate. Reduced booking errors by 30% through the use of transactional consistency and error handling during high-traffic periods.",
    image: "https://i.ibb.co/P1YQt24/Screenshot-2024-10-31-at-7-24-53-PM.png",
    tags: [
      "Docker",
      "AWS",
      "Gin-gonic",
      "Golang",
      "GORM",
      "Postgres Sql",
      "ec2",
      "Postman",
    ],
    // category: "web app",
    github: "https://github.com/Raunak173/bookmyshow-golang",
    webapp:
      "https://www.postman.com/mission-geoscientist-67700153/workspace/raunak-public-apis/collection/28779130-2fc604b8-a41f-4957-b586-ea10091712a7?action=share&creator=28779130",
  },
  {
    id: 0,
    title: "Pikagram",
    // date: "Apr 2023 - May 2023",
    description:
      "The Pikagram project is a React Native app I developed with an interface inspired by Instagram Reels, but focused on photos instead of videos. The app allows users to swipe through a feed of images in a full-screen, immersive format, similar to how Reels display content. Users can like, comment, and quickly browse photos by swiping, creating an engaging and seamless photo-browsing experience. This project showcases my skills in handling responsive design, smooth animations, and efficient state management within React Native.",
    image: "https://i.ibb.co/Z8GFB3f/Screenshot-2024-10-31-at-10-38-15-PM.png",
    tags: ["React Native, Typescript"],
    // category: "web app",
    github: "https://github.com/Raunak173/PikaGram",
    // webapp: "https://podstream.netlify.app/",
    // member: [
    //   {
    //     name: "Rishav Chanda",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 1,
    title: "AI Modelize",
    // date: "Oct 2022 - Present",
    description:
      "AiModelize is a web application designed to serve as a comprehensive catalog for AI models, providing users with a platform to explore, create, and save AI models. Use our platform to create and train your own AI models, with support for various frameworks and libraries. Discover the top 20% models with the highest viewership and engagement, curated for you.",
    image: "https://i.ibb.co/HxbBrGq/Screenshot-2024-10-31-at-10-41-31-PM.png",
    tags: ["React Js", "Node Js", "Express Js", "Redux", "Tailwind"],
    category: "web app",
    github: "https://github.com/Raunak173/AiModelize",
    webapp: "https://ai-modelize.vercel.app/",
  },
];

// export const TimeLineData = [
//   { year: 2017, text: "Started my journey" },
//   { year: 2018, text: "Worked as a freelance developer" },
//   { year: 2019, text: "Founded JavaScript Mastery" },
//   { year: 2020, text: "Shared my projects with the world" },
//   { year: 2021, text: "Started my own platform" },
// ];
